// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import store from '@/store/'
import router from './router'
import { post, get } from '@/libs/api' /* ajax 请求 */
import validata from '@/libs/validata'
import * as custom from '@/libs/filter' /*  vue模板渲染filter */
import util from '@/libs/util' /* 常用类库 */
import * as directives from '@/libs/directives' /* 自定义指令  */
import validRulers from '@/libs/validator/ruler' // 验证规则 
import Clipboard from 'clipboard' // 复制链接
import viewImage from '@/components/view-images/view-images.vue' //图片弹出
import MetaInfo from 'vue-meta-info'//meta信息


Vue.prototype.Clipboard = Clipboard;
Vue.config.productionTip = false;

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key]);
})

/* 自定义指令  */
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
})

Vue.prototype.util = util;
Vue.prototype.websiteConfigs = util.websiteConfigs; // 全局站点配置
Vue.prototype.validRulers = validRulers.validRulers; // 验证规则
Vue.prototype.validata = validata;
Vue.prototype.post = post;
Vue.prototype.get = get;


Vue.use(ElementUI);
Vue.component('viewImage', viewImage);
Vue.use(MetaInfo);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  // components: { App },
  // template: '<App/>'
  render: h => h(App),
  mounted() {
    // document.dispatchEvent(new Event('render-event'))
    document.dispatchEvent(new Event('custom-render-trigger'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js